<template>
	<v-container class="pt-6" fluid style="height: 100%">
		<div class="pb-3" style="position: absolute; left: 12px; top: 24px; height: calc(100% - 24px)">
			<v-navigation-drawer width="240" :mini-variant-width="'64'" class="elevation-0 rounded" :color="$vuetify.theme.dark ? '#1E1E1E' : 'white'"
				><!-- clipped -->
				<a class="text-left d-block py-3 pl-2 primary--text" @click="$router.push({ path: '/uams/apps' })"><v-icon class="primary--text" style="vertical-align: bottom">mdi-chevron-left</v-icon> 返回</a>
				<v-divider />
				<div class="navi-hd text-center mt-12">
					<v-avatar size="86" color="blue-grey lighten-5" style="border-radius: 18px">
						<v-icon color="primary" size="36">{{ appsd.apps.props }}</v-icon>
					</v-avatar>
					<div class="title mt-3">{{ appsd.apps.name || "加载中..." }}</div>
					<v-subheader class="d-inline-block mt-1">{{ appsd.apps.type | dict("1:治理端/2:服务端/3:协同端") }}·{{ appsd.apps.leve | dict("0:国家级应用/2:省级应用/4:市级应用/6:区县级应用") }}</v-subheader>
				</div>
				<!-- 左侧菜单 -->
				<v-list shaped>
					<template v-for="list in navis">
						<v-list-group v-if="list.items.length" :key="list.title" :prepend-icon="list.icon" :class="$vuetify.theme.dark ? 'black--text' : 'white--text'" :active-class="$vuetify.theme.dark ? 'white--text' : 'brown--text'" :group="list.group">
							<template v-slot:activator>
								<v-list-item-content>
									<v-list-item-title>{{ list.title }}</v-list-item-title>
								</v-list-item-content>
							</template>
							<v-list-item active-class="secondary primary--text" v-for="item in list.items" :key="item.title" :to="`${item.path}?aid=${appsd.apps.id}`">
								<v-list-item-action>
									<v-icon>{{ item.icon }}</v-icon>
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title>{{ item.title }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-group>
						<v-list-item v-else v-show="appsd.apps.type != '2' || list.title == '基本信息' || list.title == '视图设置'" active-class="secondary primary--text" :key="list.path" :to="`${list.path}?aid=${appsd.apps.id}`">
							<v-list-item-action>
								<v-icon>{{ list.icon }}</v-icon>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title>{{ list.title }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</template>
				</v-list>
			</v-navigation-drawer>
		</div>
		<keep-alive>
			<router-view :appsd="appsd" @refresh="view" />
		</keep-alive>
	</v-container>
</template>

<script>
import Message from "@/components/message";
import Request from "@/commons/request";
export default {
	data: () => ({
		navis: [
			{
				title: "基本信息",
				path: "/uams/apps-view",
				icon: "mdi-atom-variant",
				group: "/uams_app",
				items: [],
			},
			{
				title: "视图设置",
				path: "/uams/apps-grids",
				icon: "mdi-cellphone-link",
				note: "用户管理中心，为省、市、区三级用户管理人员提供集中的用户管理功能。",
				group: "/uams_app",
				items: [],
			},
			{
				title: "应用菜单",
				path: "/uams/apps-menu",
				icon: "mdi-ballot-outline",
				note: "应用管理中心，包括应用的注册、修改、菜单等；治理端可以管理治理端、服务端、协同端所有应用。",
				group: "/uams_app",
				items: [],
			},
			{
				title: "应用角色",
				path: "/uams/apps-roles",
				icon: "mdi-account-cog-outline",
				note: "用户管理中心，为省、市、区三级用户管理人员提供集中的用户管理功能。",
				group: "/uams_app",
				items: [],
			},
			{
				title: "应用授权",
				path: "/uams/apps-roots",
				icon: "mdi-cellphone-cog",
				note: "用户管理中心，为省、市、区三级用户管理人员提供集中的用户管理功能。",
				group: "/uams_app",
				items: [],
			},
		],
		appsd: { apps: {}, acid: {} },
	}),
	created() {
		this.view(this.$route.query.aid);
	},
	watch: {
		$route(to, from) {
			to.query.aid && to.query.aid != from.query.aid && this.view(to.query.aid);
		},
	},
	methods: {
		view(aid) {
			Message.loading.show();
			Request.postForm("/app/apps/view", { id: aid }).then((res) => {
				Message.loading.hide();
				this.appsd = res.data;
			});
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep .theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {
	background-color: rgba(0, 0, 0, 0);
}
</style>
